import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useRouteTransition = () => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Don't show loading for home page
    if (location.pathname === '/') {
      setIsTransitioning(false);
      return;
    }

    setIsTransitioning(true);
    
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 800); // Reduced loading time

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return { isTransitioning };
};